import { getOsData, pushDataLayer } from '@libs';
import { useTranslations } from '@libs/translations';
import { OS_OPTIONS } from '@constants/params';
import { useEffect, useState } from "react";
import { IS_CLIENT, OS } from "@constants";

export const getABTestingVariants = (locale) => {
  const translations = useTranslations();
  const { downloadLink } = OS_OPTIONS[os];
  const [downloadLinks, setDownloadLink] = useState({
    current: OS_OPTIONS[OS.WINDOWS].getDownloadLink(locale),
    second: OS_OPTIONS[OS.MAC].getDownloadLink(locale)
  });

  useEffect(() => {
    if (IS_CLIENT) {
      const { downloadLink, os } = getOsData(locale);
      const secondOc = os === OS.WINDOWS ? OS.MAC : OS.WINDOWS;

      setDownloadLink({
        current: downloadLink,
        second: OS_OPTIONS[secondOc].getDownloadLink(locale),
      });
    }
  }, []);

  return {
    0: {
      href: `/${locale}/demo/`,
      onClick: () => {
        pushDataLayer({
          event: 'gaEvent',
          gaCategory: 'ABTesting',
          gaAction: 'click',
          gaLabel: 'Исходный вариант',
        });
      },
    },
    1: {
      href: `${downloadLinks.current}`,
      text: translations.t('site.common.downloadFree'),
      onClick: () => {
        pushDataLayer({
          event: 'gaEvent',
          gaCategory: 'ABTesting',
          gaAction: 'click',
          gaLabel: 'Вариант с кнопкой скачать (переход на страницу)',
        });
      },
    },
    2: {
      href: downloadLink,
      text: translations.t('site.common.downloadFree'),
      onClick: () => {
        pushDataLayer({
          event: 'gaEvent',
          gaCategory: 'ABTesting',
          gaAction: 'click',
          gaLabel: 'Вариант с кнопкой скачать (загрузка)',
        });
      },
    },
  };
};
